import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'HTMLSanitizerPipe'
})
export class HTMLSanitizerPipe implements PipeTransform {

    transform(text: string): string {
        return text.replace(/[\u00A0-\u9999<>\&]/gim, (char) => {
            return '&#'+char.charCodeAt(0)+';';
         });
    }
}